import { render } from "./WorkspaceDashboard.vue?vue&type=template&id=4ec051d2"
import script from "./WorkspaceDashboard.vue?vue&type=script&lang=js"
export * from "./WorkspaceDashboard.vue?vue&type=script&lang=js"

import "./WorkspaceDashboard.vue?vue&type=style&index=0&id=4ec051d2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__